exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quick-pay-notify[data-v-5c33c064] {\n  display: inline-block;\n  border: 1px dashed;\n  padding: 0.2rem 0.5rem;\n  border-radius: 3px;\n  font-size: small;\n  color: #ff8d00 !important;\n}\nform[data-v-5c33c064] {\n  position: relative;\n}\n.loader[data-v-5c33c064] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(38, 43, 66, 0.9);\n  z-index: 1;\n  display: flex;\n  align-items: center;\n}\n.loader svg[data-v-5c33c064] {\n  width: 50px;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n", ""]);

// exports
